import script from "./PhoneMyPlan.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneMyPlan.vue?vue&type=script&setup=true&lang=js"

import "./PhoneMyPlan.vue?vue&type=style&index=0&id=44fdd1e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44fdd1e7"]])

export default __exports__